export const engagementAppGroupIdEmailSettings = "/engagement/:app_group_id/email_settings";
